import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  IconButton,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Collapse,
} from "@mui/material";
import step1 from '../../../assets/step1.png'
import step2 from '../../../assets/step2.png'
import YouWon from '../../../assets/YouWon.gif'
import jsPDF from "jspdf";
import logoReceipt from '../../../assets/logo-receipt.png'
import RefundedSuccess from '../../../assets/RefundedSucces.png'
import RefundeInitfailed from '../../../assets/refundedfailed.png'
import OrderSuccessImg from '../../../assets/Order_Success.png'
import ShareIcon from "@mui/icons-material/Share";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import REFUND_UPON_REQUEST_IMG from '../../../assets/REFUND_UPON_REQUEST_IMG.png'
import SearchIcon from "../../../assets/Searching.gif"
import Cliam from "../../../assets/helpClaimBg.gif";
import RefundStatusCard from "./RefundStatusCard";
import html2canvas from 'html2canvas';
import { toast } from 'react-toastify';
import RefundProcessingReceipt from "../RefundProcessingReceipt";
import RefundSuccessfulReceipt from "../RefundSuccessfulReceipt";
import RefundUponRequestReceipt from "../RefundUponRequestReceipt";
import OrderSuccessReceipt from "../OrderSuccessReceipt";
import RefundInitiationFailedReceipt from "../RefundInitiationFailedReceipt";
import RefundFailedReceipt from "../RefundFailedReceipt";
import RefundScheduledReceipt from "../RefundScheduledReceipt";
import refundfailed from '../../../assets/refundfailed.png'
import { useLocation, useNavigate } from "react-router-dom";
import TicketRaisedModal from "./TicketRaisedModal";
import WhatsAppNumberModal from './WhatsAppModal'
import OrderHeader from "./OrderHeader";

export default function RefundStatus(props) {
      const location = useLocation();
       const params = new URLSearchParams(location.search);
   const isWebview = params.get("webview")
      const mobileNumber = params.get("mobileNumber")
     
       const id = params.get("id")
  const [share, setShare] = useState(false);
    const receiptRef = useRef(null);
    console.log("🚀 ~ file: 1.jsx:17 ~ RefundStatus ~ props:", props.orderReport   )
    const  refundStatus= props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status
    const orderId= props?.orderReport?.data?.orderId || "Order not found"
    const orderLineItem=props?.orderReport?.data?.orderLineItem || []
    const refundDetailInfoList=props?.orderReport?.data?.refundDetailInfoList || []
    const paidAmount=props?.orderReport?.data?.refundDetailInfoList[0]?.paidAmount || "N/A"
    const refundAmount=props?.orderReport?.data?.refundDetailInfoList[0]?.refundAmount || "N/A"
    const transactionId=props?.orderReport?.data?.refundDetailInfoList[0]?.transactionId || "N/A"
    const payMethod=props?.orderReport?.data?.refundDetailInfoList[0]?.payMethod || "Unknown Payment Method"
    const paidDate=props?.orderReport?.data?.refundDetailInfoList[0]?.paymentTime || "N/A"

const navigate = useNavigate();

const handleClaim = () => {
  console.log("----------------------------------------------")

  if (isWebview) {
   window.location.href = `https://www.daalchini.co.in/tagOrderId?value=${orderId}`; // external URL
  //window.location.href = `myapp:/tagOrderId?value=${orderId}`; // external URL
  //window.open(`https://www.daalchini.co.in/tagOrderId?value=${orderId}`, "_blank");
  } else {
    navigate(`/tagOrderId?value=${orderId}`); // internal route
  }
};

const handleShareReceiptImg = async () => {
  if (!receiptRef.current) {
    toast.error("Receipt reference is missing!", {
      position: "top-right",
      autoClose: 5000,
    });
    return;
  }

  setShare(true);
  props?.setLoader(true);

  try {
   
    await new Promise((resolve) => {
      requestAnimationFrame(resolve);
    });

    
    const canvas = await html2canvas(receiptRef.current, {
      scale: 2,
      scrollY: 0,
      useCORS: true,
      windowWidth: receiptRef.current.scrollWidth,
      windowHeight: receiptRef.current.scrollHeight,
    });

    const imageDataUrl = canvas.toDataURL("image/png");
    const res = await fetch(imageDataUrl);
    const blob = await res.blob();
    const file = new File([blob], "receipt.png", { type: "image/png" });

    // 3️⃣ Now share (still inside user gesture!)
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({
        title: "Order Receipt",
        text: "Here is your order receipt.",
        files: [file],
      });

      toast.success("Receipt shared successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      const link = document.createElement("a");
      link.href = imageDataUrl;
      link.download = "receipt.png";
      link.click();

      toast.info("Download started (fallback)", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  } catch (err) {
    //console.error("Error during sharing:", err);
    toast.error(
      `${err?.response?.data?.statusMessage || "Failed to share receipt!"}`,
      {
        position: "top-right",
        autoClose: 5000,
      }
    );
  } finally {
    setShare(false);
    props?.setLoader(false);
  }
};


const RefundStatusReceipt = ({ props, formatpaymentTime, formatrefundInitiatedTime, formatrefundCreditExpectedTime, formatrefundCreditTime, receiptRef ,totalRefundAmount,share}) => {
  //console.log("share",share)

  return (
    <div style={{ position: "absolute", zIndex: "-100" ,display:share?"":"none",width:"100%"}}>
    <div className="max-w-md mx-auto mt-10  rounded-2xl shadow-md p-4 font-sans text-sm" style={{ backgroundColor: "rgb(253 224 71)" }}  ref={receiptRef}>
      <div className="bg-white rounded-xl p-4"
       style={{marginBottom:"20vw",marginTop:"20vw"}}>
        <h2 className="text-gray-800 font-semibold text-base"> Order_{props && props.orderReport && props.orderReport.data.orderId}</h2>
        <p className="text-gray-500 text-xs mb-4">{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime ? formatpaymentTime : "Not Availabel"}</p>


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATED" && 
  <RefundProcessingReceipt
  orderReport={props.orderReport}
  formatrefundInitiatedTime={formatrefundInitiatedTime}
  formatrefundCreditExpectedTime={formatrefundCreditExpectedTime}
  formatpaymentTime={formatpaymentTime}
  step1Img={step1}
/>

        }
        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_SUCCESSFUL" && 
 <RefundSuccessfulReceipt
  orderReport={props.orderReport}
  formatrefundInitiatedTime={formatrefundInitiatedTime}
  formatrefundCreditTime={formatrefundCreditTime}
  formatpaymentTime={formatpaymentTime}
  step2Img={step2}
/>

        }
        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_UPON_REQUEST" &&
 <RefundUponRequestReceipt
  orderReport={props.orderReport}
  formatpaymentTime={formatpaymentTime}
  refundImage={REFUND_UPON_REQUEST_IMG}
/>


        }

        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_NOT_REQUIRED" &&
<OrderSuccessReceipt
  orderReport={props.orderReport}
  formatpaymentTime={formatpaymentTime}
  OrderSuccessImg={OrderSuccessImg}
/>

        }


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_INITIATION_FAILED" &&
   <RefundInitiationFailedReceipt
  orderReport={props.orderReport} 
  formatpaymentTime={formatpaymentTime} 
  failedImg={refundfailed}
/>



        }


        {props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status === "REFUND_FAILED" &&
   <RefundFailedReceipt
  orderReport={props&&props.orderReport} 
  formatpaymentTime={formatpaymentTime} 
  failedImg={RefundeInitfailed}
/>




        }

{props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].status == "REFUND_SCHEDULED"&&

<RefundScheduledReceipt
  orderReport={props.orderReport}
  formatrefundCreditExpectedTime={formatrefundCreditExpectedTime}
  formatpaymentTime={formatpaymentTime}
  RefundedSuccess={RefundedSuccess}
  totalRefundAmount={totalRefundAmount}
/>



}


        <div className="mt-5 flex justify-center">
          <img src={logoReceipt} alt="Daalchini Logo" className="h-10"  />
        </div>
      </div>
    </div>
    </div>

  );
};



  // ✅ Independent expand states
  const [expanded, setExpanded] = useState({
    order: false,
    payment: false,
  });

  const handleToggle = (section) => {
    setExpanded((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };


const convertToIST = (dateString) => {
  if (!dateString) return "";

  // Force UTC
  const date = new Date(dateString + "Z");

  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};



  function convertUTCtoIST(utcDateString) {
  const utcDate = new Date(utcDateString);
  // Add 5 hours and 30 minutes (IST offset)
  const istOffset = 5.5 * 60 * 60 * 1000; // milliseconds
  const istDate = new Date(utcDate.getTime() + istOffset);
  return istDate.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
}


const getStatusChips = (item) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        justifyContent: "flex-end",
        flexWrap: "wrap",
      }}
    >
      {/* SUCCESS */}
      {item.successQuantity > 0 && (
        <Chip
        style={{fontSize:"12px"}}
          label={`Success (${item.successQuantity})`}
         // size="small"
          sx={{
            fontWeight: 600,
            bgcolor: "#e6f6f0",
            color: "#00a676",
          }}
        />
      )}

      {/* FAILED */}
      {item.failureQuantity > 0 && (
        <Chip
        style={{fontSize:"12px"}}
          label={`Failed (${item.failureQuantity})`}
          //size="small"
          sx={{
            fontWeight: 600,
            bgcolor: "#ffeaea",
            color: "#d32f2f",
          }}
        />
      )}

      {/* ✅ PENDING ADDED */}
      {item.vendRemaining > 0 && (
        <Chip
          label={`Pending (${item.vendRemaining})`}
          //size="small"
          style={{fontSize:"12px"}}
          sx={{
            fontWeight: 600,
            bgcolor: "#fff4e5",
            color: "#F28618",
          }}
        />
      )}
    </Box>
  );
};


  const totalRefundAmount = props && props.orderReport && props.orderReport.data.refundDetailInfoList.reduce(
    (sum, refund) => sum + (refund.refundAmount || 0),
    0
  );
  const formatpaymentTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].paymentTime)

  const formatrefundInitiatedTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundInitiatedTime)


  const formatrefundCreditExpectedTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundCreditExpectedTime)
  const formatrefundCreditTime = convertUTCtoIST(props && props.orderReport && props.orderReport.data.refundDetailInfoList[0].refundCreditTime);
  
  const HandleRaiseTicket = (e, props,mobileNumber) => {
  // 1. First priority = query param number
  if (mobileNumber) {
    props?.setWhatsappnum(mobileNumber);
    props?.handleTicket(mobileNumber);
    return;
  }

  // 2. Second priority = localStorage number
  const localMobile = localStorage.getItem("mobileNo");

  if (localMobile) {
    props?.setWhatsappnum(localMobile);
    props?.handleTicket(localMobile);
    return;
  }

  // 3. If neither exists → open WhatsApp modal
  props?.setOpenWhatsappModal(true);
};

  return (
    <>
    {!isWebview&&<OrderHeader/>}
          {props&&props.tickeRaiseSuccesFlag&&<TicketRaisedModal  setTickeRaiseSuccesFlag={props&&props.setTickeRaiseSuccesFlag}  raiseTicketData={props&&props.raiseTicketData} orderReport={props&&props.orderReport}/>}
 <RefundStatusReceipt props={props} formatpaymentTime={formatpaymentTime} formatrefundInitiatedTime={formatrefundInitiatedTime} formatrefundCreditExpectedTime={formatrefundCreditExpectedTime} formatrefundCreditTime={formatrefundCreditTime} receiptRef={receiptRef} totalRefundAmount={totalRefundAmount} share={share}/>    
     {props&&props.openWhatsappModal &&
          <WhatsAppNumberModal handleTicket={props && props.handleTicket} setWhatsappnum={props && props.setWhatsappnum} whatsappnum={props&&props.whatsappnum} setOpenWhatsappModal={props&&props.setOpenWhatsappModal}  />}
    <Box
      sx={{
        bgcolor: "#ffffff",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 900,
          borderRadius: 4,
          boxShadow: 0,
        }}
      >
        <CardContent sx={{ p: {  md: 3 } }}  style={{boxShadow:"none",padding:"0"}} >

          {/* HEADER */}
          <Stack direction="row" justifyContent="space-between">
            <Box>
              <Typography fontWeight={700}>
                Order_{orderId}
              </Typography>

              <Typography variant="body2" color="text.secondary">
            {convertToIST(refundDetailInfoList[0]?.paymentTime)}
              </Typography>
            </Box>

           { !(isWebview) && <IconButton onClick={()=>{handleShareReceiptImg()}}>
              <ShareIcon />
            </IconButton>
}
          </Stack>

 
          <RefundStatusCard refundStatus={refundStatus} refundDetailInfoList={refundDetailInfoList} refundDate="10th April" refundTime="3 PM"  payMethod={payMethod} refundAmount={refundAmount}/>    


          {/* ORDER TABLE */}
          <Box mt={2}>
            <Box
              onClick={() => handleToggle("order")}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                bgcolor: "rgba(238,247,244,0.88)",
                p: 2,
                borderRadius: 2,
                "&:hover": { bgcolor: "rgba(238,247,244,0.95)" },
              }}
            >
              <Typography fontWeight={700} fontSize={"14px"}>
                Order : {orderLineItem.length} Items
              </Typography>

              <IconButton
                sx={{
                  transform: expanded.order
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "0.3s",
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Box>

            <Collapse in={expanded.order}>
              <TableContainer
                component={Paper}
                sx={{
                  mt: 1,
                  borderRadius: 3,
                  boxShadow: "none",
                  border: "1px solid #eee",
                  bgcolor: "rgba(238,247,244,0.88)",
                }}
              >
                <Table >
                  <TableHead >
                    <TableRow sx={{  }}>
                      <TableCell sx={{ fontWeight: 500 }}  style={{    backgroundColor: "rgba(238,247,244,0.88)",fontSize:"12px"}} >
                        Item (Count)
                      </TableCell>

                      <TableCell align="center" sx={{ fontWeight: 500 }} style={{ backgroundColor: "rgba(238,247,244,0.88)",fontSize:"12px" }} >
                        Price Per Unit
                      </TableCell>

                      <TableCell align="right" sx={{ fontWeight: 500 }} style={{ backgroundColor: "rgba(238,247,244,0.88)" ,fontSize:"12px"}} >
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {orderLineItem.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{fontSize:"12px"}}>{item.variantName}</TableCell>
                        <TableCell style={{fontSize:"12px"}} align="center">{item.amount}</TableCell>
                        <TableCell style={{fontSize:"12px"}} align="right">
                            {getStatusChips(item)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </Box>

          {/* PAYMENT */}
          <Box
            mt={2}
            sx={{
              bgcolor: "rgba(238,247,244,0.88)",
              borderRadius: 2,
              p: 2,
            }}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              onClick={() => handleToggle("payment")}
              sx={{ cursor: "pointer" }}
            >
              <Typography fontWeight={700} fontSize={"14px"}>
                Paid Amount : ₹{paidAmount}
              </Typography>

              <IconButton
                size="small"
                sx={{
                  transform: expanded.payment
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "0.25s",
                }}
              >
                <ExpandMoreIcon />
              </IconButton>
            </Stack>

            <Collapse in={expanded.payment}>
              <Divider sx={{ my: 1 }} />

              <Typography variant="body2" style={{fontSize:"12px"}}>
             {convertToIST(paidDate)}
              </Typography>

              <Typography variant="body2" style={{fontSize:"12px"}}>
                Transaction ID:{transactionId}
              </Typography>

              <Typography variant="body2" style={{fontSize:"12px"}}>
                Payment Method: {payMethod}
              </Typography>
            </Collapse>
            {console.log("refundStatus---",refundStatus=="REFUND_SCHEDULED")}
          </Box>

          {/* REWARD */}
          {refundStatus=="REFUND_SCHEDULED"&&
            <Box
            mt={1}
            sx={{
              position: "relative",
              borderRadius: 3,
              overflow: "hidden",
              p: { xs: 3, md: 4 },
              
              textAlign: "center",
              backgroundImage: `url(${Cliam})`,
             backgroundSize: "cover",
             

            }}
            display={"flex"}
            justifyContent={"center"}
            style={{paddingLeft:"0px",paddingBottom:"0px", background: "linear-gradient(to bottom, #A1C6B8 0%, #EEF6F3 100%)",}}
          >
            <img src={YouWon} style={{width:"100px",position:"relative",zIndex:"999999"}}/>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                bgcolor: "rgba(238,247,244,0.88)",
                  backgroundImage: `url(${Cliam})`,
                    backgroundSize: "cover",
              }}
            />

            <Box sx={{ position: "relative" }}>
              <Typography fontWeight={800} fontSize={16} textAlign={"start"}>
                Reward Unlocked!
              </Typography>

              <Typography variant="body2" mb={0} fontSize={12}>
                You've Won Cashback On This Order
              </Typography>
<div style={{    display: "flex",
    justifyContent: "flex-start"}}>
            <Button
  variant="contained"
  onClick={()=>{handleClaim()}}

  style={{position:"absolute",zIndex:999}}
  endIcon={
    <Box
      sx={{
        bgcolor: "#fff",
        color: "#00a676",
        borderRadius: "50%",
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ArrowForwardIcon fontSize="small" />
    </Box>
  }
  sx={{
    bgcolor: "#00a676",
    borderRadius: 8,
    px: 4,
    fontWeight: 700,
    pl:"8px",
    pr:"8px",
    height:"28px",
    mt:"5px",

    // ✅ ADD THIS
    "& .MuiButton-endIcon": {
      marginLeft: "16px", // increase gap here
    },

    "&:hover": { bgcolor: "#008f63" },
  }}
>
  Claim Now
</Button>
<img src={Cliam} style={{position:"absolute",top:"-14pxpx",right:"-24px"}}/>
</div>

            </Box>
          </Box>}
              {refundStatus=="REFUND_INITIATED"&&

                <Box
            mt={1}
            sx={{
              position: "relative",
              borderRadius: 3,
              overflow: "hidden",
              p: { xs: 3, md: 4 },
              
              textAlign: "center",
              backgroundImage: `url(${Cliam})`,
              backgroundSize: "cover",
             

            }}
            display={"flex"}
            justifyContent={"center"}
            style={{paddingLeft:"0px",paddingBottom:"0px", background: "linear-gradient(to bottom, #A1C6B8 0%, #EEF6F3 100%)",}}
          >
            <img src={YouWon} style={{width:"100px",position:"relative",zIndex:"999999"}}/>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                bgcolor: "rgba(238,247,244,0.88)",
                  backgroundImage: `url(${Cliam})`,
                    backgroundSize: "cover",
              }}
            />

            <Box sx={{ position: "relative" }}>
              <Typography fontWeight={800} fontSize={16} textAlign={"start"}>
                Reward Unlocked!
              </Typography>

              <Typography variant="body2" mb={0} fontSize={12}>
                You've Won Cashback On This Order
              </Typography>
<div style={{    display: "flex",
    justifyContent: "flex-start"}}>
            <Button
  variant="contained"
  onClick={()=>{handleClaim()}}
  style={{position:"absolute",zIndex:999}}
  
  endIcon={
    <Box
      sx={{
        bgcolor: "#fff",
        color: "#00a676",
        borderRadius: "50%",
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ArrowForwardIcon fontSize="small" />
    </Box>
  }
  sx={{
    bgcolor: "#00a676",
    borderRadius: 8,
    px: 4,
    fontWeight: 700,
    pl:"8px",
    pr:"8px",
    height:"28px",
    mt:"5px",

    // ✅ ADD THIS
    "& .MuiButton-endIcon": {
      marginLeft: "16px", // increase gap here
    },

    "&:hover": { bgcolor: "#008f63" },
  }}
>
  Claim Now
</Button>

</div>
<img src={Cliam} style={{position:"absolute",top:"-14px",right:"-24px"}}/>

            </Box>
          </Box>
         }

       {refundStatus=="REFUND_SUCCESSFUL"&&
                  <Box
            mt={1}
            sx={{
              position: "relative",
              borderRadius: 3,
              overflow: "hidden",
              p: { xs: 3, md: 4 },
              
              textAlign: "center",
              backgroundImage: `url(${Cliam})`,
             backgroundSize: "cover",
             

            }}
            display={"flex"}
            justifyContent={"center"}
            style={{paddingLeft:"0px",paddingBottom:"0px", background: "linear-gradient(to bottom, #A1C6B8 0%, #EEF6F3 100%)",}}
          >
            <img src={YouWon} style={{width:"100px",position:"relative",zIndex:"999999"}}/>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                bgcolor: "rgba(238,247,244,0.88)",
                  backgroundImage: `url(${Cliam})`,
                    backgroundSize: "cover",
              }}
            />

            <Box sx={{ position: "relative" }}>
              <Typography fontWeight={800} fontSize={16} textAlign={"start"}>
                Reward Unlocked!
              </Typography>

              <Typography variant="body2" mb={0} fontSize={12}>
                You've Won Cashback On This Order
              </Typography>
<div style={{    display: "flex",
    justifyContent: "flex-start"}}>
            <Button
  variant="contained"
  onClick={()=>{handleClaim()}}

    style={{position:"absolute",zIndex:999}}
  endIcon={
    <Box
      sx={{
        bgcolor: "#fff",
        color: "#00a676",
        borderRadius: "50%",
        width: 22,
        height: 22,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ArrowForwardIcon fontSize="small" />
    </Box>
  }
  sx={{
    bgcolor: "#00a676",
    borderRadius: 8,
    px: 4,
    fontWeight: 700,
    pl:"8px",
    pr:"8px",
    height:"28px",
    mt:"5px",

    // ✅ ADD THIS
    "& .MuiButton-endIcon": {
      marginLeft: "16px", // increase gap here
    },

    "&:hover": { bgcolor: "#008f63" },
  }}
>
  Claim Now
</Button>

</div>
<img src={Cliam} style={{position:"absolute",top:"-14px",right:"-24px"}}/>

            </Box>
          </Box>}
      

          {/* HELP */}
          <Box
            mb={isWebview=="true"?id?0:"50px":0}
            mt={2}
            sx={{
              bgcolor: "#eef7f4",
              borderRadius: 3,
             // p: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
             style={{padding:"12px"}}
          >
            <img src={SearchIcon} alt="search" style={{ width: 90 }} />

            <Box textAlign="center">
              <Typography fontWeight={700} mb={1}>
                Have Any Concerns?
              </Typography>

              <Button
                onClick={(e) =>HandleRaiseTicket(e,props,mobileNumber)}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  color: refundStatus === "REFUND_INITIATION_FAILED" ? "#ffffff" :  "#00a676",
                  backgroundColor: refundStatus === "REFUND_INITIATION_FAILED" ? "#00a676" : "#ffffff",
                  borderColor: "#00a676",
                  
                  fontWeight: 600,
                  "&:hover": {
                    borderColor: "#008f63",
                    color: "#008f63",
                  },
                }}
              >
                Raise A Ticket
              </Button>
            </Box>
          </Box>

        </CardContent>
      </Card>
    </Box>
     </>
  );

}
